import React, { useEffect, useState } from "react";
import { I18nProvider as LinguiI18nProvider } from "@lingui/react";
import { initializeI18n, i18n } from "@/lib/i18n";

interface I18nProviderProps {
  children: React.ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadI18n = async () => {
      try {
        await initializeI18n();
      } catch (error) {
        console.error("Failed to initialize i18n:", error);
        // Fallback is handled inside initializeI18n function
      } finally {
        setIsLoading(false);
      }
    };

    loadI18n();
  }, []);

  // Show loading spinner while initializing i18n
  if (isLoading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">
            Loading language preferences...
          </p>
        </div>
      </div>
    );
  }

  // Wrap children with Lingui's I18nProvider to provide i18n context
  return <LinguiI18nProvider i18n={i18n}>{children}</LinguiI18nProvider>;
}
